import styled from 'styled-components';
import { rgba } from 'polished';

// COLORS
import { BLACK, GALLERY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  .faq {
    &__title {
      margin-bottom: 60px;

      ${breakpoints.down('sm')} {
        margin-bottom: 30px;
      }
    }

    &__list {
      > div:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }
  }

  &.faq {
    &--with-border {
      .faq {
        &__list {
          .collapsable-container {
            border: 1px solid ${GALLERY};
            box-shadow: 1px 1px 6px 0 ${rgba(BLACK, 0.08)};
          }
        }
      }
    }
  }
`;

export default Container;
